import React from 'react';
import axios from 'axios';
import authenService from '../utils/services/authenService';
import { store } from '../utils/redux/store';

export default () => {

  
  const states = store.getState();

  const _authenService = new authenService();
  let accessToken = states.authenReducer.accessToken;
  const refreshToken = states.authenReducer.refreshToken;
  const accessTokenExp = states.authenReducer.tokenExpire;
  const d1 = new Date();
  const d2 = new Date(accessTokenExp * 1000);
  if (d2 < d1) {
    accessToken =  _authenService.refreshToken(refreshToken);
  }


  // const accessToken = localStorage.getItem("persist:loop_store");
  const memComId = localStorage.getItem("memComId");
  
  // const token = localStorage.getItem("token");

  // //console.log("authenReducer",accessToken)

  const headers = {
    // "Access-Control-Allow-Origin" : "*",
    Authorization : `Bearer ${accessToken}`,
    // memComId : memComId
  };

  if(memComId != undefined) {
    // headers.memComId = memComId;
  }

  const baseURL = `${process.env.REACT_APP_URL_MANAGER_ADD_PORT}`;

  return axios.create({
    baseURL,
    headers,
  });
};